import { ChevronUp, Info, PlusCircle} from "react-feather";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../Router/all_routes.jsx";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../core/redux/action.jsx";
import ArrowLeft from "feather-icons-react/build/IconComponents/ArrowLeft";
import { renderRequired} from '../common/common.js';
// Utility function for email validation
const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

// Utility function for mobile number validation
const isValidMobileNumber = (number) => /^\d{10}$/.test(number);

const ManageClient = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  // const [client, setClient] = useState({
  //   clientName: "",
  //   unitName: "",
  //   unitLocation: "",
  //   contactPersons: [
  //     {
  //       department: "",
  //       designation: "",
  //       mobileNumber: "",
  //       mailId: "",
  //     },
  //   ],
  // });
  const [client, setClient] = useState({
    clientName: "dfgdfg",
    unitName: "dfgdfg",
    unitLocation: "dfgdfgdfg",
    contactPersons: [
        {
            department: "UI/UX",
            designation: "Developer",
            mobileNumber: "1234567489",
            mailId: "df@gmailo.com"
        },
        {
            department: "Support",
            designation: "Developer",
            mobileNumber: "1234567489",
            mailId: "df@gmail.com"
        }
    ]
});
  const [errors, setErrors] = useState({});

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const departments = [
    { value: "Choose", label: "Choose" },
    { value: "UI/UX", label: "UI/UX" },
    { value: "Support", label: "Support" },
  ];

  const designations = [
    { value: "Choose", label: "Choose" },
    { value: "Designer", label: "Designer" },
    { value: "Developer", label: "Developer" },
    { value: "Tester", label: "Tester" },
  ];

  const handleChange = (e) => {
    setClient({
      ...client,
      [e.target.name]: e.target.value,
    });
  };

  const handleContactPersonChange = (index, e) => {
    const updatedContactPersons = client.contactPersons.map((person, i) =>
      i === index ? { ...person, [e.target.name]: e.target.value } : person
    );
    setClient({ ...client, contactPersons: updatedContactPersons });
  };

  const handleSelectChange = (index, selectedOption, actionMeta) => {
    const updatedContactPersons = client.contactPersons.map((person, i) =>
      i === index
        ? { ...person, [actionMeta.name]: selectedOption.value }
        : person
    );
    setClient({ ...client, contactPersons: updatedContactPersons });
  };

  const addContactPersonForm = () => {
    setClient({
      ...client,
      contactPersons: [
        ...client.contactPersons,
        {
          department: "",
          designation: "",
          mobileNumber: "",
          mailId: "",
        },
      ],
    });
  };

  const removeContactPersonForm = (index) => {
    const updatedContactPersons = client.contactPersons.filter((_, i) => i !== index);
    setClient({ ...client, contactPersons: updatedContactPersons });
  };

  const validateForm = () => {
    const newErrors = {};

    // Validate client details
    if (!client.clientName) newErrors.clientName = "Client Name is required";
    if (!client.unitName) newErrors.unitName = "Unit Name is required";
    if (!client.unitLocation)
      newErrors.unitLocation = "Unit Location is required";

    // Validate each contact person
    const contactPersonErrors = client.contactPersons.map((person) => {
      const personErrors = {};
      if (!person.department) personErrors.department = "Department is required";
      if (!person.designation) personErrors.designation = "Designation is required";
      if (!person.mobileNumber) personErrors.mobileNumber = "Mobile Number is required";
      else if (!isValidMobileNumber(person.mobileNumber)) personErrors.mobileNumber = "Invalid Mobile Number format";
      if (!person.mailId) personErrors.mailId = "Mail Id is required";
      else if (!isValidEmail(person.mailId)) personErrors.mailId = "Invalid Email format";
      return personErrors;
    });

    setErrors({ ...newErrors, contactPersons: contactPersonErrors });
    return (
      Object.keys(newErrors).length === 0 &&
      contactPersonErrors.every((personErrors) => Object.keys(personErrors).length === 0)
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // If validation is successful, log data to the console
      console.log("Form Data:", client);
      // alert("Client data saved successfully!");
      // You can send data to API here
    } 
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>New Client</h4>
                <h6>Create new Client</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <div className="page-btn">
                  <Link to={route.client} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                    Back to Client List
                  </Link>
                </div>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="card">
              <div className="card-body">
                <div className="new-employee-field">
                  <div className="card-title-head">
                    <h6>
                      <span>
                        <Info className="feather-edit" />
                      </span>
                      Client Information
                    </h6>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Client Name {renderRequired()}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="clientName"
                          value={client.clientName}
                          onChange={handleChange}
                        />
                        {errors.clientName && (
                          <span className="text-danger">
                            {errors.clientName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Unit Name {renderRequired()}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="unitName"
                          value={client.unitName}
                          onChange={handleChange}
                        />
                        {errors.unitName && (
                          <span className="text-danger">
                            {errors.unitName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Unit Location {renderRequired()}</label>
                        <input
                          type="text"
                          className="form-control"
                          name="unitLocation"
                          value={client.unitLocation}
                          onChange={handleChange}
                        />
                        {errors.unitLocation && (
                          <span className="text-danger">
                            {errors.unitLocation}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {client.contactPersons.map((person, index) => (
                    <div key={index} className="contact-person-form">
                      <div className=" d-flex  align-items-center mb-3">
                        <span>Contact Person {index + 1}</span>
                        <spam className="d-flex justify-content-end align-items-center" style={{color:'$warning'}}><i className="bx bx-x-circle" style={{  fontSize:'20px', justifyContent:'center', borderRadius:'50px', color:"#FF9F43", border: "1px", paddingLeft:'5px'}}   onClick={() => removeContactPersonForm(index)} /></spam>

                        
                      </div>
                      <hr/>
                      <div className="row">
                        <div className="col-lg-6 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Department {renderRequired()}</label>
                            <Select
                              classNamePrefix="react-select"
                              options={departments}
                              placeholder="Choose"
                              name="department"
                              value={departments.find(
                                (dep) => dep.value === person.department
                              )}
                              onChange={(selectedOption, actionMeta) =>
                                handleSelectChange(
                                  index,
                                  selectedOption,
                                  actionMeta
                                )
                              }
                            />
                            {errors.contactPersons?.[index]?.department && (
                              <span className="text-danger">
                                {errors.contactPersons[index].department}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Designation {renderRequired()}</label>
                            <Select
                              classNamePrefix="react-select"
                              options={designations}
                              placeholder="Choose"
                              name="designation"
                              value={designations.find(
                                (des) => des.value === person.designation
                              )}
                              onChange={(selectedOption, actionMeta) =>
                                handleSelectChange(
                                  index,
                                  selectedOption,
                                  actionMeta
                                )
                              }
                            />
                            {errors.contactPersons?.[index]?.designation && (
                              <span className="text-danger">
                                {errors.contactPersons[index].designation}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Mobile Number {renderRequired()}</label>
                            <input
                              type="text"
                              className="form-control"
                              name="mobileNumber"
                              value={person.mobileNumber}
                              onChange={(e) =>
                                handleContactPersonChange(index, e)
                              }
                            />
                            {errors.contactPersons?.[index]?.mobileNumber && (
                              <span className="text-danger">
                                {errors.contactPersons[index].mobileNumber}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Mail Id {renderRequired()}</label>
                            <input
                              type="text"
                              className="form-control"
                              name="mailId"
                              value={person.mailId}
                              onChange={(e) =>
                                handleContactPersonChange(index, e)
                              }
                            />
                            {errors.contactPersons?.[index]?.mailId && (
                              <span className="text-danger">
                                {errors.contactPersons[index].mailId}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={addContactPersonForm}
                    >
                      <PlusCircle className="me-2" />
                      Add Contact Person
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-end mb-3">
              <Link to={route.client} type="button" className="btn btn-cancel me-2">
             
                Cancel
              </Link>
              <button type="submit" className="btn btn-submit">
                Save Client
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ManageClient;
